export const TRAFFIC_LIGHT_COLORS = {
    red: 'red',
    yellow: 'yellow',
    green: 'green',
} as const;
